<template>
  <div class="my_order">
    <div class="order_main">
      <div class="order_left">
        <user-tab></user-tab>
      </div>

      <div class="order_right">
        <div class="about">
          <div class="about-title">关于聚师傅</div>
          <div
            class="about-content"
          >聚师傅作为专业从事家居服务的行业O2O平台，致力于提供家居配送、安装、维修、保养等一站式服务，解决家居售后环节成本高、服务质量差、管理难度大等棘手问题。聚师傅创世团队前身已拥有多年家居配送、安装服务相关经验，已和数千名安装师傅达成合作关系，服务范围覆盖国内多座城市。聚师傅平台深度结合微信连接能力，实现线上下单、抢单、支付、资金托管、评价等功能，极大程度提升效率的同时也推进了行业标准、诚信机制的建立。客户通过聚师傅下单后可以自主选择师傅确定报价并全程掌握订单服务情况，师傅通过实名认证和培训之后即可通过平台接单获得收益，过程中消费者可以享受到更有品质的服务，实现了多方共赢。</div>
          <div
            class="about-content"
            style="padding-bottom:20px;"
          >聚师傅是一家以技术为成长驱动的公司，从成立伊始，就投入大量资源开发完善可靠、能够不断升级、以应用服务为核心的自有技术平台，从而驱动家居服务能力的提升。未来聚师傅将会发展大数据、人工智能、AR/VR、智能硬件等最新技术，以推动家居服务行业更大的变革。</div>
          <!-- <img src="../../assets/img/logo.png" alt=""> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userTab from "./../../components/user/user_tab";
export default {
  components: {
    userTab
  },
  data() {
    return {
      aboutData:{}
    };
  },
  mounted() {
    var _this = this;
    for (let i of _this.$store.state.headerTabList) {
      i.isSelected = false;
      if (i.name == "关于我们") {
        i.isSelected = true;
      }
    }
    for (let i of _this.$store.state.userList) {
      i.isSelected = false;
      if (i.name == "关于我们") {
        i.isSelected = true;
      }
    }
    this.$fetch(
        `/common/api/article?pageIndex=1&pageSize=50&typeCode=about`
      ).then(res => {
        if (res.code == 0) {
          _this.aboutData = res.data;
        } else {
          this.$message(res.message);
        }
      });
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.about {
  background: #ffffff;
  .about-title {
    padding: 32px 30px;
    color: #2f3133;
    line-height: 1;
    font-size: 16px;
    font-weight: bold;
  }
  .about-content {
      padding: 0 30px;
    font-size: 12px;
    color: rgba(94, 96, 102, 1);
    line-height: 24px;
    margin-bottom: 20px;
  }
  img{
      width: 463px;
      margin-left: 30px;
      margin-bottom: 50px;
  }
}
</style>